import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'summit',
    description:
      "Plan and monitor the execution of your organization's strategic vision.",
    icon: 'summit',
    name: 'Summit',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
